import { NullValueCell } from "./NullValueCell";
import { SkeletonCell } from "./SkeletonCell";

/** AG Grid components registered in both DynamicGrid and GridRenderer */
export const baseGridComponents = { NullValueCell } as const;

/** AG Grid components registered only in DynamicGrid (infinite/server-side model) */
export const fullGridComponents = { NullValueCell, SkeletonCell } as const;
